/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Detail monetized similar listings constants
 */

export const START_FETCHING_MONETIZED_SIMILAR_LISTINGS =
  '@@nzr/Detail/START_FETCHING_MONETIZED_SIMILAR_LISTINGS'
export const CLEAR_MONETIZED_SIMILAR_LISTINGS = '@@nzr/Detail/CLEAR_MONETIZED_SIMILAR_LISTINGS'
export const DONE_FETCHING_MONETIZED_SIMILAR_LISTINGS =
  '@@nzr/Detail/DONE_FETCHING_MONETIZED_SIMILAR_LISTINGS'
export const ERROR_FETCHING_MONETIZED_SIMILAR_LISTINGS =
  '@@nzr/Detail/ERROR_FETCHING_MONETIZED_SIMILAR_LISTINGS'
export const RECEIVE_MONETIZED_SIMILAR_LISTINGS = '@@nzr/Detail/RECEIVE_MONETIZED_SIMILAR_LISTINGS'
